import { render, staticRenderFns } from "./tabInfos.vue?vue&type=template&id=0feb7e5c&scoped=true&"
import script from "./tabInfos.vue?vue&type=script&lang=js&"
export * from "./tabInfos.vue?vue&type=script&lang=js&"
import style0 from "./tabInfos.vue?vue&type=style&index=0&id=0feb7e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feb7e5c",
  null
  
)

export default component.exports